import React from "react";
import { useSelector } from "react-redux";

const AppContainer = ({ children }) => {
  const { theme } = useSelector((state) => state.theme);

  return <div className={`${theme}-THEME`}>{children}</div>;
};
export default AppContainer;
